import { formatBrussels, nowBrussels, toBrussels } from './brussels-datetime';

/**
 * Horodatage relatif d'une ligne de boîte de réception : l'heure aujourd'hui, le jour cette
 * semaine, la date au-delà. Les libellés sont fournis par l'app (mobile : français en dur,
 * web : traductions). Partagé pour que mobile et web découpent « aujourd'hui » de la même façon.
 */
export const horodatageCourt = (iso: string | null | undefined, labels: { justNow: string }) => {
	if (!iso) return '';

	const date = toBrussels(iso);
	const maintenant = nowBrussels();
	const ecoule = maintenant.toMillis() - date.toMillis();

	if (ecoule < 60_000) return labels.justNow;

	if (date.hasSame(maintenant, 'day')) {
		return formatBrussels(iso, 'fr-BE', { hour: '2-digit', minute: '2-digit' });
	}

	if (ecoule < 7 * 24 * 3_600_000) {
		return formatBrussels(iso, 'fr-BE', { weekday: 'short' });
	}

	return formatBrussels(iso, 'fr-BE', { day: '2-digit', month: '2-digit' });
};

/** Séparateur de jour dans le fil de messages. */
export const libelleJour = (iso: string, labels: { today: string; yesterday: string }) => {
	const date = toBrussels(iso);
	const maintenant = nowBrussels();

	if (date.hasSame(maintenant, 'day')) return labels.today;
	if (date.hasSame(maintenant.minus({ days: 1 }), 'day')) return labels.yesterday;

	return formatBrussels(iso, 'fr-BE', { weekday: 'long', day: 'numeric', month: 'long' });
};
